<template>
  <footer class="footer-area bg-white text-center rounded-top-7">
    <p class="fs-14">
      © <span class="text-primary-div">SN-DDE</span> — Système Gestion Équestre du Sénégal
    </p>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
